module.exports = __webpack_public_path__ + "img/success.a88e9e58.png";